import React, { useEffect, useMemo } from 'react';
import Orders from '../order';
import Position from './List';
import { makePositionNoReduceSelector, makeTradeDialogSelector } from '../../../redux/selector';
import { useAppDispatch, useAppSelector } from '../../../redux/app';
import useSubscribe from '../hooks/useSubscribe';
// import { GetSymbolFromQoute } from './GetSymbolFromQoute';
import { setSymbolSubscribe } from '../../../redux/reducer/instruments';
import { GetSymbolFromQoute } from '@vt/vt-trading-utils';
import PositionBackgroundCalculator from './PositionBackgroundCalculator';
import { setTradeDialog } from '../../../redux/reducer/dialog';

const PositionTable = ({ type }) => {
  const dispatch = useAppDispatch();
  const getPositionState = useMemo(makePositionNoReduceSelector, []);
  const positions = useAppSelector((state) => getPositionState(state));
  const { subscribe } = useSubscribe();
  const getTradeDialog = useMemo(makeTradeDialogSelector, []);
  const tradeDialog = useAppSelector((state) => getTradeDialog(state));
  const tickReady = useAppSelector(({ onTickReady }) => onTickReady?.onTickReady ?? false);
  const symbol = useAppSelector((state) => state.symbol?.instruments);

  const getSymbolFromQoute = new GetSymbolFromQoute(symbol.map((item) => item.symbol));

  window.addEventListener('contextmenu', (event) => {
    if (event.button === 2) {
      event.preventDefault();
    }
  });

  // console.log("check =>>", getSymbolFromQoute.getSymbolFromQoute("EUR"))

  const symbolKey = useMemo(() => {
    return symbol.reduce((acc, item) => {
      return {
        ...acc,
        [item.symbol]: {
          currency_profit: item.currency_profit,
          ...item
        }
      };
    }, {});
  }, [symbol]);

  const getSymbolSubscribe = useMemo(() => {
    return positions.reduce((acc, item) => {
      const symbolData = symbol.find((e) => e.symbol === item.symbol);
      if (symbolData) {
        return {
          ...acc,
          [item.symbol]: {
            currency_base: symbolData.currency_base,
            currency_profit: symbolData.currency_profit,
            rateProfit: item.rateProfit
          }
        };
      }
      return acc;
    }, {});
  }, [positions, symbol]);

  useEffect(() => {
    if (tickReady) {
      (async () => {
        let a = [];

        if (positions.length > 0) {
          const findPositionSymbol = positions.map((item) => {
            return [
              item.symbol,
              getSymbolFromQoute.getSymbolFromQoute(getSymbolSubscribe[item.symbol].currency_profit)
                .symbol
            ];
          });

          // Group symbols by removing duplicates
          const symbolsToSubscribe = findPositionSymbol.reduce((acc, [symbol, rateSymbol]) => {
            if (!acc[symbol]) {
              acc[symbol] = [];
            }
            if (rateSymbol && !acc[symbol].includes(rateSymbol)) {
              acc[symbol].push(rateSymbol);
            }
            return acc;
          }, {});

          // Flatten the grouped symbols into a single array
          const uniqueSymbols = [
            ...new Set([
              ...Object.keys(symbolsToSubscribe),
              ...Object.values(symbolsToSubscribe).flat()
            ])
          ].filter(Boolean);
          // console.log('uniqueSymbols', uniqueSymbols)
          dispatch(setSymbolSubscribe(uniqueSymbols));
          await subscribe(uniqueSymbols);
        }
      })();
    }
  }, [positions, tickReady, getSymbolSubscribe, symbolKey]);

  if (type === 'port') {
    return (
      <div
        style={{
          transform: type === 'port' ? 'translateX(0%)' : 'translateX(-120%)',
          position: 'fixed',
          left: '80px',
          top: '65px',
        }}
        id="positionsEle" className='bg-[#151515]'>
        <div className='text-[#e5e5e5] text-md font-bold p-4 flex justify-between items-center border-r border-[#232323]'>All Port
          <div
            className="border-r border-r-[#232323] h-full flex cursor-pointer"
            onClick={() => {
              dispatch(setTradeDialog({ isOpen: false, type: '' }))
            }}>
            <svg
              className="m-auto history-btn-action"
              width="11"
              height="11"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.781396 16.0001C0.626858 16.0001 0.475783 15.9543 0.347281 15.8685C0.218778 15.7826 0.118621 15.6606 0.0594776 15.5178C0.000334661 15.3751 -0.0151369 15.218 0.0150198 15.0664C0.0451766 14.9148 0.119607 14.7756 0.228896 14.6664L14.6664 0.228853C14.8129 0.0823209 15.0117 0 15.2189 0C15.4261 0 15.6249 0.0823209 15.7714 0.228853C15.9179 0.375385 16.0002 0.574125 16.0002 0.781353C16.0002 0.988581 15.9179 1.18732 15.7714 1.33385L1.3339 15.7714C1.26141 15.844 1.17528 15.9016 1.08047 15.9408C0.985653 15.9801 0.884016 16.0002 0.781396 16.0001Z"
                fill="#9f9f9f"
              />
              <path
                d="M15.2189 16.0001C15.1162 16.0002 15.0146 15.9801 14.9198 15.9408C14.825 15.9016 14.7388 15.844 14.6664 15.7714L0.228853 1.33385C0.0823209 1.18732 0 0.988581 0 0.781353C0 0.574125 0.0823209 0.375385 0.228853 0.228853C0.375385 0.0823209 0.574125 0 0.781353 0C0.988581 0 1.18732 0.0823209 1.33385 0.228853L15.7714 14.6664C15.8806 14.7756 15.9551 14.9148 15.9852 15.0664C16.0154 15.218 15.9999 15.3751 15.9408 15.5178C15.8816 15.6606 15.7815 15.7826 15.653 15.8685C15.5245 15.9543 15.3734 16.0001 15.2189 16.0001Z"
                fill="#9f9f9f"
              />
            </svg>
          </div>
        </div>
        <div className={`position-dialog border-r border-[#232323]`}>
          <div className="header">
            <div className="grid grid-cols-[20%_55%_25%] flex-header">
              <p className='text-[#e5e5e5]'>Position</p>
              <div className="flex items-center gap-2">
                <p className="mr-9 text-[#e5e5e5]">Symbol</p>
                <p className='text-[#e5e5e5]'>Type</p>
                <p className='text-[#e5e5e5]'>Volume</p>
              </div>
              <p className="text-end text-[#e5e5e5]">PL($)</p>
            </div>
          </div>
          <div id="custom-order-scroll" className={type === 'port' ? 'table-position-scroll' : ''}>
            <Position isOpen={tradeDialog.isOpen} data={positions} />
            <Orders />
          </div>
        </div>
        <PositionBackgroundCalculator />
      </div>
    );
  }
  return <PositionBackgroundCalculator />
};

PositionTable.displayName = 'PositionTable';

export default PositionTable;
